import React, { Component } from 'react';
import store from "../../store/index"
import { connect } from "react-redux"
import { eventBus } from '../../utils/tool';
import { ethers } from 'ethers';
import SweetAlert2 from 'react-sweetalert2';
import throttle from 'lodash/debounce';
import Spinner from 'react-bootstrap/Spinner';

import copy from 'copy-to-clipboard'
const idoContract = "0xaddD149b1993E0c335eBa4eCd522d495F03A6cEA"
const payTokenContract = '0x1962650786D6E81BFC5c5998aF8344c54124eF61' // 要支付的代币的合约
// const nodeRpc = "https://bsc-dataseed4.ninicoin.io"
const nodeRpc = 'https://exchainrpc.okex.org/'
// const 
// const nodeRpc = "https://data-seed-prebsc-1-s1.binance.org:8545/"
const abi = [
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "Paused",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "Unpaused",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "invitor",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "payAmount",
                "type": "uint256"
            }
        ],
        "name": "buySuccess",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "claimAmount",
                "type": "uint256"
            }
        ],
        "name": "claimRewardSuccess",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "claimAmount",
                "type": "uint256"
            }
        ],
        "name": "claimTokenSuccess",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "newBeginTime",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "newEndTime",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "inviter",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "rewardAmount",
                "type": "uint256"
            }
        ],
        "name": "reward",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "inviter",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            }
        ],
        "name": "updateInvitor",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "Pause",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "USDT",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "XMFWalletAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "_invitor",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "_userClaimTokenCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "_usersId",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "payAmount",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "invitor",
                "type": "address"
            }
        ],
        "name": "buyToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "buyerNumbs",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "buyerNumbsLimit",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyer_claimed_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyer_got_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyer_pay_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyer_token_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "canBeClaimDogeReward",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "canClaimToken",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "canBeClaim",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "checkCap",
        "outputs": [],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "checkFiveAnd1000U",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "checkStatus",
        "outputs": [],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "checkTheTokenBlance",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "totalPayAmount",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_soldUSDTAmount",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "totalUserCanClaimToken",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_sellToken",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "aaa",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "bbb",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "ccc",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "claimBalance",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "claimBuyerToken_2",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "claimToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "dogeToken",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "enableClaimBuyerToken",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getAllUser",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "getBalanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "getCanBeClaimBuyerToken_2",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "getCanBeClaimReward",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "getRewardUSDT",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "userId",
                "type": "uint256"
            }
        ],
        "name": "getUserById",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "getUserIfBuy",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "getUserSubordinateInfo",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "_ind",
                "type": "uint256"
            }
        ],
        "name": "getUserSubordinateInfoById",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "getUserSubordinateTotalBuyU",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "totalBuy",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getUsersCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "hardCup",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "idoBeginTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "idoEndTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdtAmount",
                "type": "uint256"
            }
        ],
        "name": "ifBuy",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "inviterCountsForUser",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitorNumbs",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitorNumbs2",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "invitorRewardPercentList",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitor_got_reward_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitor_reward_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "isPause",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "lenOfInvitorRewardPercentList",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "maxPayToBuyAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "minPayToBuyAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addresses",
                "type": "address[]"
            },
            {
                "internalType": "uint256[]",
                "name": "tokens",
                "type": "uint256[]"
            }
        ],
        "name": "multiBuyerTokenAmount",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addresses",
                "type": "address[]"
            },
            {
                "internalType": "address",
                "name": "newInvitor",
                "type": "address"
            }
        ],
        "name": "multiInvitor",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addresses",
                "type": "address[]"
            },
            {
                "internalType": "bool",
                "name": "status",
                "type": "bool"
            }
        ],
        "name": "multiSetWLs",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "needFivePeopleAnd1000U",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "inviterNumbs",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "inviterAllU",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "price",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "rejectContract",
        "outputs": [],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "sellDogeTokenAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setBeginTime",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setBuyerNumbsLimit",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bool",
                "name": "s",
                "type": "bool"
            }
        ],
        "name": "setCheckFiveAnd1000U",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "token",
                "type": "address"
            }
        ],
        "name": "setDogeToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bool",
                "name": "status",
                "type": "bool"
            }
        ],
        "name": "setEnableClaimBuyerToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setEndTime",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setHardCup",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "newValue",
                "type": "uint256[]"
            }
        ],
        "name": "setInvitorRewardPercentList",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setMaxPayToBuyAmount",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setMinPayToBuyAmount",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setPrice",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newU",
                "type": "address"
            }
        ],
        "name": "setUSDT",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setUserMaxClaimCount",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newAddr",
                "type": "address"
            }
        ],
        "name": "setXMFWalletAddress",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "soldUSDTAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "unPause",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "userMaxClaimCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "whitelistedUsers",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "stateMutability": "payable",
        "type": "receive"
    }
]

const tokenAbi = [{ "constant": true, "inputs": [], "name": "name", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "guy", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "approve", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "src", "type": "address" }, { "name": "dst", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "wad", "type": "uint256" }], "name": "withdraw", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }], "name": "balanceOf", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "dst", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "transfer", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "deposit", "outputs": [], "payable": true, "stateMutability": "payable", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }, { "name": "", "type": "address" }], "name": "allowance", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "payable": true, "stateMutability": "payable", "type": "fallback" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": true, "name": "guy", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": true, "name": "dst", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "dst", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Deposit", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Withdrawal", "type": "event" }]


const initData = {
    img: "/img/logo.jpg",
    blockchain: "/img/binance.png",
    title: "MetaDoge",
    reg_date: "2022-11-30",
    raise: "100k",
    val: "2.8M",
    allocation: "$0",
    progress: "25%",
    mecha: "0/100,069 MECHA",
    busd: "0 BUSD",
    actionBtn: "Contribute", // 提取代币 参与IDO
    video_img: "/img/thumb_6.png",
    video_icon: "fa-solid fa-play",
    video_link: "https://www.youtube.com/watch?v=fzBTvDraO5U",
    idoToken: "",
    total: "", // 当前购买总数
    purchaseCap: "", // 每个人能买多少
    hardCap: 0, // 硬顶
    startTime: "", // 开始时间戳
    endTime: "" // 结束时间戳
}

const summaryData = {
    title: "Project Summary",
    content_1: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    content_2: "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth."
}

const overviewData = {
    title: "Project Overview",
    list_heading: "Lorem ipsum dolor sit",
    content: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.",
}

const tokenmetricsData = {
    title: "Token Metrics",
    content: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
}

const roadmapData = {
    title: "Roadmap",
    content_1: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    content_2: "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth."
}

const socialData = [
    {
        id: "1",
        link: "https://twitter.com/MetaDoge_Core",
        icon: "fab fa-twitter"
    },
    {
        id: "2",
        link: "https://t.me/Metadoge_GlobalCommunity",
        icon: "fab fa-telegram"
    },
    // {
    //     id: "3",
    //     link: "globe",
    //     icon: "fas fa-globe"
    // },
    // {
    //     id: "4",
    //     link: "discord",
    //     icon: "fab fa-discord"
    // }
]

const overviewList = [
    {
        id: "1",
        content: "Far far away",
    },
    {
        id: "2",
        content: "Behind the word mountains",
    },
    {
        id: "3",
        content: "Far from the countries Vokalia and Consonantia",
    },
    {
        id: "4",
        content: "There live the blind texts",
    }
]

const tokenList = [
    {
        id: "1",
        title: "Fundraised:",
        content: "$500,000",
    },
    {
        id: "2",
        title: "Platfrom Raise:",
        content: "$120,000 + $5,000",
    },
    {
        id: "3",
        title: "Price:",
        content: "$0.05",
    },
    {
        id: "4",
        title: "Lock-up:",
        content: "25% unlocked on TGE, 4 months cliff, then 5% on a monthly basis",
    }
]

class ProjectSingle extends Component {
    constructor() {
        super()
        this.state = {
            initData: {},
            summaryData: {},
            overviewData: {},
            tokenmetricsData: {},
            roadmapData: {},
            socialData: [],
            overviewList: [],
            tokenList: [],
            invitorAddress: '',
            invotorInvitorAddress: '',
            buyAmount: 0, // 已购入数量
            preBuyAmount: 0, // 预计购入数量
            swal: {},
            inputValue: '',
            linkInvitor: '',
            buyLoading: false,
            ethBalance: 0,
            invitorNumbers: 0, // 下级人数
            invitorRefUSDTAmount: 0, // 下级购买的总USDT数量
        }
        this.handleInput = throttle(this.handleBuyInputAmount, 300)

    }

    handleBuyInputAmount() {
        console.log(this.state.inputValue)
        // 去列表中获取
        if (this.state.account) {
            const provider = new ethers.providers.JsonRpcProvider(nodeRpc)
            const contract = new ethers.Contract(idoContract, abi, provider)
            contract.ifBuy(ethers.utils.parseUnits(this.state.inputValue + '', 18))
                .then(res => {
                    // console.log('预计购买', res.toString() / 1e18)
                    this.setState({
                        preBuyAmount: res.toString() / 1e18
                    })
                })
        }
    }




    componentDidMount() {
        this.setState({
            initData: initData,
            summaryData: summaryData,
            overviewData: overviewData,
            tokenmetricsData: tokenmetricsData,
            roadmapData: roadmapData,
            socialData: socialData,
            overviewList: overviewList,
            tokenList: tokenList,
            account: ""
        });

        eventBus.addListener("walletConnect", this.walletConnect.bind(this))
        // 获取信息
        // setTimeout(() => {
        //     // 获取连接的钱包
        // }, 2000);
    }
    componentWillUnmount() {
        eventBus.removeListener("walletConnect", this.walletConnect.bind(this))
    }

    walletConnect(v) {
        console.log('监控到账户连接', v)
        if (v.account) {
            // 执行初始化操作
            this.setState({
                account: v.account
            }, () => {
                this.fetchData()
            })
        }
    }

    async fetchData() {
        // 分两步, 先获取跟钱包无关的数据, 再获取跟钱包有关的数据
        // 根据钱包地址获取数据
        // 获取总募资数量
        // 当前用户参与数量
        // 当前用户邀请数量
        // 当前用户可领取的代币数量
        // IDO代币的信息
        // 当前账户是否在白名单中
        // purchaseCap 最大购买金额
        // totalPurchasedAmount 已经购买的USDT数量
        // hardCup 硬顶
        // startTime 开始时间
        // endTime 结束时间
        // ido 代币地址
        // let provider = null
        // const provider = new ethers.providers.Web3Provider(window.ethereum)
        const provider = new ethers.providers.JsonRpcProvider(nodeRpc)
        const search = window.location.search
        const params = new URLSearchParams(search);
        const invitor = params.get('invitor')
        if (invitor) {
            this.setState({
                linkInvitor: invitor
            })
        }

        if (this.state.account) {
            // 获取当前地址的上级地址
            // 获取当前邀请链接的上级地址
            // 1. 获取已购买的代币数量(需要连接钱包)
            const contract = new ethers.Contract(idoContract, abi, provider)
            const token = new ethers.Contract(payTokenContract, tokenAbi, provider)
            contract._invitor(this.state.account)
                .then(res => {
                    if (res !== '0x0000000000000000000000000000000000000000') {
                        this.setState({
                            invitorAddress: res
                        })
                    }

                })

            contract.inviterCountsForUser(this.state.account)
                .then(res => {
                    console.log('下级人数', res.toString())
                    this.setState({
                        invitorNumbers: parseInt(res.toString())
                    })
                })
            // contract.invitor_refUSDTAmount(this.state.account)
            //     .then(res => {
            //         console.log('下级购买总量', res.toString() / 1e18)
            //         this.setState({
            //             invitorRefUSDTAmount: res.toString() / 1e18
            //         })
            //     })
            if (invitor) {
                contract._invitor(invitor)
                    .then(res => {
                        if (res !== '0x0000000000000000000000000000000000000000') {
                            this.setState({
                                invotorInvitorAddress: res
                            })
                        }

                    })
            }
            provider.getBalance(this.state.account)
                .then(res => {
                    console.log('余额是', res.toString() / 1e18)
                    this.setState({
                        ethBalance: parseFloat(res.toString() / 1e18)
                    })
                })




            token.balanceOf(this.state.account)
                .then(res => {
                    console.log('payToken余额是', res.toString() / 1e18)
                    this.setState({
                        payTokenBalance: parseFloat(res.toString() / 1e18)
                    })
                })

        }

        // const ethcallProvider = new Provider(provider);
        // await ethcallProvider.init();
        // const abi = [
        //     'function ido() external view returns(address)',
        //     'function purchaseCap() public view returns(uint256)',
        //     'function totalPurchasedAmount() public view returns(uint256)',
        //     'function hardCup() public view returns(uint256)',
        //     'function startTime() public view returns(uint256)',
        //     'function endTime() public view returns(uint256)',
        //     'function whitelist(address _addr) public view returns(bool)',
        //     'function _dontNeedWLtoBuy(address _addr) public view returns(bool)',
        //     'function purchasedAmounts(address _addr) public view returns(uint256)',
        //     'function invitorAmount(address _addr) public view returns(uint256)',
        //     'function claimedAmounts(address _addr) public view returns(uint256)',
        //     'function claimedInvitorAmount(address _addr) public view returns(uint256)',
        //     'function _invitor(address _addr) public view returns(address)',
        // ]
        // const ido = new Contract(idoContract, abi)

        // // 获取用户代币余额
        // const calls = [
        //     ido.ido(),
        //     ido.purchaseCap(),
        //     ido.totalPurchasedAmount(),
        //     ido.hardCup(),
        //     ido.startTime(),
        //     ido.endTime(),
        // ]
        // const res = await ethcallProvider.all(calls)
        // console.log(res)
        // this.setState({
        //     initData: {
        //         ...this.state.initData,
        //         idoToken: res[0],
        //         purchaseCap: res[1].toString() / 1e18,
        //         total: res[2].toString() / 1e18,
        //         hardCap: res[3].toString() / 1e18,
        //         startTime: res[4].toString() / 1e18,
        //         endTime: res[5].toString() / 1e18
        //     }
        // })

        // // 已经连接钱包, 获取连接数量
        // if (this.state.account) {
        //     // 是否在白名单里
        //     // 是否在不需要白名单也能买的账户里
        //     // 付款数量
        //     // 可领取的推荐奖励数
        //     // 已领取的推荐奖励数
        //     // claimedAmounts 已领取代币数
        //     // 'function whitelist(address _addr) public view returns(bool)',
        //     //     'function _dontNeedWLtoBuy(address _addr) public view returns(bool)',
        //     //     'function purchasedAmounts(address _addr) public view returns(uint256)',
        //     //     'function invitorAmount(address _addr) public view returns(uint256)',
        //     //     'function claimedAmounts(address _addr) public view returns(uint256)',
        //     //     'function claimedInvitorAmount(address _addr) public view returns(uint256)',
        //     //     'function _invitor(address _addr) public view returns(address)',
        //     const account = this.state.account
        //     const c2 = [
        //         ido.whitelist(account),
        //         ido._dontNeedWLtoBuy(account),
        //         ido.purchasedAmounts(account),
        //         ido.invitorAmount(account),
        //         ido.claimedAmounts(account),
        //         ido.claimedInvitorAmount(account),
        //         ido._invitor(account),
        //     ]
        //     const r = await ethcallProvider.all(c2)
        //     console.log('钱包相关', r)
        //     this.setState({
        //         initData: {
        //             ...this.state.initData,
        //             inWhitelist: r[0],
        //             inNotWlToBuy: r[1],
        //             purchasedAmounts: r[2].toString() / 1e18,
        //             invitorAmount: r[3].toString() / 1e18,
        //             claimedAmounts: r[4].toString() / 1e18,
        //             claimedInvitorAmount: r[5].toString() / 1e18,
        //             _invitor: r[6].toString() / 1e18
        //         }
        //     })
        // }


    }

    // 根据合约, 获取IDO信息
    // 参与IDO
    // 领取代币
    // 上级地址
    // 分级数量
    // IDO有多种方式: 有硬顶 没硬顶 不显示已购买数量 参与数量 一份=多少代币 

    render() {
        return (
            <section className="item-details-area">



                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-12 col-lg-5">
                            {/* Project Card */}
                            <div className="card project-card no-hover">
                                <div className="media">
                                    <img className="card-img-top avatar-max-lg" src='https://token-monitor.s3.amazonaws.com/1680501997166WechatIMG31694.jpeg' alt="" />
                                    <div className="media-body ml-4">
                                        <h4 className="m-0">LionRock </h4>
                                        <div className="countdown-times">
                                            <h6 className="my-2">购入数量:</h6>
                                            <div style={{ height: "20px" }} className="countdown d-flex" data-date={this.state.initData.reg_date} >
                                                {this.state.preBuyAmount.toFixed(2)} Lion
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Project Body */}
                                <div className="card-body">
                                    {/* <div className="items">
                                        <div className="single-item">
                                            <span>IDO Number</span>
                                            <span> {this.state.initData.total || 0} USDT</span>
                                        </div>
                                        <div className="single-item">
                                            <span>Price</span>
                                            <span> 10USDT=1200Demo</span>
                                        </div>
                                        <div className="single-item">
                                            <span>Purchased</span>
                                            <span>  {this.state.initData.purchasedAmounts || 0} USDT</span>
                                        </div>
                                    </div> */}

                                    <div>
                                        <input onChange={(e) => {
                                            console.log(e)
                                            this.setState({
                                                inputValue: e.target.value
                                            }, () => {
                                                this.handleInput(e)
                                            })

                                        }} style={{ 'borderRadius': '20px' }} type="text" defaultValue={this.state.inputValue} placeholder="输入要购买的USDT数量" required="required" />
                                    </div>
                                    {/* {
                                        this.state.initData.hardCap > 0 &&
                                        <div className="item-progress">
                                            <div className="progress mt-4 mt-md-5">
                                                <div className="progress-bar" role="progressbar" style={{ width: '25%' }} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}>20USDT</div>
                                            </div>
                                            <div className="progress-sale d-flex justify-content-between mt-3">
                                                <span>{this.state.initData.mecha}</span>
                                                <span>{this.state.initData.busd}</span>
                                            </div>
                                        </div>
                                    } */}

                                </div>
                                {/* Project Footer */}
                                <div className="project-footer d-flex align-items-center mt-4 mt-md-5">
                                    <span onClick={async () => {
                                        if (this.state.buyLoading) {
                                            return
                                        }
                                        const a = parseFloat(this.state.inputValue)
                                        if (a < 0.3) {
                                            this.setState({
                                                swal: {}
                                            }, () => {
                                                this.setState({
                                                    swal: {
                                                        show: true,
                                                        title: '最低购买0.3USDT'
                                                    }
                                                })
                                            })
                                            return
                                        }


                                        if (this.state.ethBalance < a) {
                                            this.setState({
                                                swal: {}
                                            }, () => {
                                                this.setState({
                                                    swal: {
                                                        show: true,
                                                        title: '余额不足'
                                                    }
                                                })
                                            })
                                            console.log('当前余额', this.state.ethBalance)
                                            return
                                        }


                                        // console.log(111)
                                        // store.dispatch({ type: 'add' })
                                        // alert("当前项目为示例项目, 仅供示范, 无法参与IDO")
                                        this.setState({
                                            buyLoading: true
                                        })
                                        try {
                                            const provider = new ethers.providers.Web3Provider(window.ethereum)
                                            const contract = new ethers.Contract(idoContract, abi, provider.getSigner())
                                            // console.log(this.state.linkInvitor)
                                            const x = await contract.BUY(this.state.linkInvitor || '0x0000000000000000000000000000000000000000', {
                                                value: ethers.utils.parseEther(this.state.inputValue + '')
                                            })
                                            await x.wait()
                                            this.fetchData()
                                            this.setState({
                                                swal: {}
                                            }, () => {
                                                this.setState({
                                                    swal: {
                                                        show: true,
                                                        title: '交易成功'
                                                    }
                                                })
                                            })
                                        } catch (e) {
                                            console.log(e)
                                            if (e.reason) {
                                                this.setState({
                                                    swal: {}
                                                }, () => {
                                                    this.setState({
                                                        swal: {
                                                            show: true,
                                                            title: e.reason,
                                                            type: 'error'
                                                        }
                                                    })
                                                })
                                            }
                                        }

                                        this.setState({
                                            buyLoading: false
                                        })

                                    }} className="btn btn-bordered-white btn-smaller" href="/login">
                                        {/* {this.state.initData.actionBtn} */}
                                        {this.state.buyLoading && <div>
                                            <Spinner animation="border" style={{ 'height': '16px', 'width': '16px', 'marginRight': '6px' }} variant="light" />
                                            购买中...
                                        </div>}
                                        {!this.state.buyLoading && <div>
                                            购买
                                        </div>}

                                    </span>
                                    {/* Social Share */}
                                    <div className="social-share ml-auto">
                                        <ul className="d-flex list-unstyled">
                                            {this.state.socialData.map((item, idx) => {
                                                return (
                                                    <li key={`sd_${idx}`}>
                                                        <a href={item.link}>
                                                            <i className={item.icon} />
                                                        </a>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                {/* Blockchain Icon */}
                                <div className="blockchain-icon">
                                    <img src={this.state.initData.blockchain} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-7 items mt-5 mt-lg-0">
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">您的邀请链接</h3>
                                {/* <p style={{ 'overflow': 'hidden', 'textOverflow': 'ellipsis', 'display': '-webkit-box', 'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': '2' }}>
                                    {window.location.origin}?invitor={this.state.account}
                                </p> */}
                                <p>
                                    {window.location.origin}?invitor={this.state.account}
                                </p>
                                <p>
                                    <div onClick={() => {
                                        const url = window.location.origin + '?invitor=' + this.state.account
                                        copy(url)
                                        this.setState({
                                            swal: {}
                                        }, () => {
                                            this.setState({
                                                swal: {
                                                    show: true,
                                                    title: '已复制',
                                                    text: '已复制邀请链接到剪贴板'
                                                }
                                            });
                                        })


                                    }} className="btn btn-bordered-white btn-smaller">
                                        复制
                                    </div>
                                </p>

                            </div>
                            {(this.state.invitorAddress) && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">上级地址</h3>
                                <p style={{ 'overflow': 'hidden', 'textOverflow': 'ellipsis', 'display': '-webkit-box', 'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': '2' }}>
                                    {this.state.invitorAddress}
                                </p>
                                <p>
                                    <div onClick={() => {
                                        copy(this.state.invitorAddress)
                                        this.setState({
                                            swal: {}
                                        }, () => {
                                            this.setState({
                                                swal: {
                                                    show: true,
                                                    title: '已复制',
                                                    text: '已复制上级地址到剪贴板'
                                                }
                                            });
                                        })
                                    }} className="btn btn-bordered-white btn-smaller">
                                        复制
                                    </div>
                                </p>

                            </div>}
                            {this.state.buyAmount > 0 && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h4 className="m-0">已购入数量:  {this.state.buyAmount / 1e18} USDT</h4>
                            </div>}
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h4 className="m-0">邀请人数:  {this.state.invitorNumbers} </h4>
                            </div>
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h4 className="m-0">下级地址购买总量:  {this.state.invitorRefUSDTAmount.toFixed(2)}USDT </h4>
                            </div>
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">1. 项目介绍</h3>
                                <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                    香港獅子山基金會（Hong Kong Lion Rock Foundation，簡稱HKLR）是一家來自香港的區塊鏈加密團隊，是由香港各界社會人士共同發起主管的公募基金會，成立於2023年2月25日，專註於研發和推廣先進的區塊鏈技術。我們致力於創建一個安全、高效、去中心化的全新公鏈，旨在連接全球加密貨幣用戶、開發者和企業，為未來加密經濟的蓬勃發展奠定基石。基金會順應香港當局的最新政策，積極維護香港民眾以及大陸民眾在區塊鏈領域的投資理財安全保障，打造亞洲新公鏈。在有關司局、社會人士的大力支持和幫助下，香港獅子山基金會通過管理模式以及區塊鏈業務上的不斷探索，在自身事業上取得了長足的發展。
                                </p>
                            </div>
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">2. 项目概况</h3>
                                <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                    香港獅子山基金會推出的公鏈名為獅子山鏈（Lion Rock Chain，簡稱Lion）。Lion基於最新的共識算法和區塊鏈技術，為用戶提供一個穩定、高效和可擴展的公鏈生態系統。Lion具有以下特點：
                                    <br />
                                    高性能：Lion采用高度優化的共識算法，確保快速的交易確認和高吞吐量。
                                    <br />
                                    安全可靠：Lion的安全性得到了多層次加密和去中心化共識機製的保障，防止雙重支付和網絡攻擊。
                                    <br />
                                    易用性：Lion提供了簡潔的智能合約編程接口，方便開發者快速構建和部署各類去中心化應用（DAPPS）。
                                    <br />
                                    生態多樣化：LION支持跨鏈互操作，與主流公鏈如以太坊、波卡等實現資產互通，打造一個繁榮的區塊鏈生態。
                                    <br />
                                    <br />
                                </p>
                                <p>
                                    香港獅子山基金會即將發布獨特的LION代幣，開創新的加密貨幣生態。為了實現平滑過渡和廣泛推廣，Lion代幣將首先在幣安智能鏈（Binance Smart Chain，簡稱BSC）上進行發行。這一舉措旨在為LION公鏈的啟動和推廣鋪平道路，提高其在市場上的認可度。隨著Lion公鏈的正式上線，原先在BSC上發行的Lion代幣將被映射到獅子山鏈上。這一過程將實現BSC上的Lion代幣與公鏈上的Lion代幣價值對等，形成一個完整的加密貨幣生態系統。這樣一來，用戶在不同鏈上持有的Lion代幣將具有統一價值，便於在多個鏈上進行流通和交易。為了慶祝Lion代幣在BSC上的發布並激勵社區積極參與，我們將推出一系列活動，包括空投、質押挖礦等，讓廣大用戶和投資者共享Lion生態的發展紅利。我們誠摯邀請全球加密貨幣用戶、開發者和企業加入我們的生態系統，共同推動Lion公鏈的繁榮發展。讓我們攜手共創未來加密經濟的黃金時代，以Lion為橋梁，連接全球加密世界。
                                </p>
                            </div>
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">3. 经济模型</h3>
                                <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                    獅子山鏈的原生代幣名為LionROCK（簡稱Lion），Lion的經濟模型包括以下幾個方面：
                                    <br />
                                    質押與權益證明：LiON采用權益證明（PoS）共識機製，用戶可以將LiON質押到驗證節點，參與區塊產生，獲得代幣獎勵。
                                    <br />
                                    交易手續費：用戶在獅子山鏈上進行交易時需要支付一定數量的Lion作為手續費，這些手續費將用於獎勵驗證節點。
                                    <br />
                                    治理權：Lion持有者可以參與獅子山鏈的社區治理，如提案、投票等，共同決定網絡的未來發展方向。
                                </p>
                                <p>
                                    Lion代幣將首先在幣安智能鏈（Binance Smart Chain，簡稱BSC）上進行發行,總供應量為10億枚：
                                    <br />
                                    1.ICO
                                    <br />
                                    具體時間請跟進官方推特以及Telegram獲取最新信息，Lion僅有唯一ICO名額，不存在A輪B輪以及其他方式獲取。
                                    <br />
                                    2.預售額度
                                    <br />
                                    Lion擬預售1000000USDT，預售資金將全部添加流動性，發行數量以及其他數據以實際預售情況為準。
                                    <br />
                                    3.釋放方式
                                    <br />
                                    LiON預售采取全部釋放，鼓勵參與者共建生態，添加流動性LP可獲得項目團隊分紅獎勵。
                                    <br />
                                    4.代幣機製
                                    <br />
                                    稅收5%/5%，1%由基金會持有，4%給予添加流動性的自動分紅獎勵。
                                </p>

                            </div>
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">4. 發展規劃</h3>
                                <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                    香港獅子山基金會設定了以下關鍵發展階段：
                                    <br />
                                    1.公鏈測試網發布，邀請開發者和社區成員進行測試，激勵計劃啟動。
                                    <br />
                                    2.公鏈主網上線，完成Lion代幣映射，支持多鏈資產跨鏈互通。
                                    <br />
                                    3.推出DAPPS開發者大賽，鼓勵全球開發者基於獅子山鏈構建各類去中心化應用。
                                    <br />
                                    4.啟動獅子山鏈生態基金，支持優秀項目孵化和發展。
                                    <br />
                                    5.推出獅子山鏈智能合約安全審計工具，提升生態安全性。
                                    <br />
                                    6.與全球主流加密交易所達成合作，提高Lion流通性和知名度。
                                    <br />
                                    7.獅子山鏈生態進入成熟階段，全面支持NFT、DeFi、遊戲等各類應用場景。 獅子山鏈作為一個專註於建設安全、高效、去中心化的區塊鏈生態系統的項目，香港獅子山基金會將與全球合作夥伴、開發者和社區成員緊密合作，共同推動獅子山鏈及其生態的繁榮發展。我們相信，在未來的加密經濟時代，獅子山鏈將成為連接全球加密用戶、開發者和企業的重要橋梁。
                                    <br />
                                    <br />
                                    擬計劃於2023年5月召開香港記者發布會，說明基金會願景布局，以及主網上線詳細信息。

                                </p>
                            </div>

                        </div>
                    </div>
                </div>
                <SweetAlert2 {...this.state.swal} />
            </section>
        );
    }
}

function mapStateToProps(state) {
    const account = state.account;
    return {
        account,
        // text
    };
}

// export default ProjectSingle;
export default connect(mapStateToProps)(ProjectSingle)